import React from 'react';
import banner1 from '../img/bg/banner8.jpg'
import banner2 from '../img/bg/banner9.jpg'
import {NavLink} from "react-router-dom";
import {CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER} from "../utils/consts";

const Banner = () => {
    return (
        <div className="banner_area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <figure className="single_banner">
                            <div className="banner_thumb">
                                <NavLink to={CATEGORY_FLOOR_BOARD}><img src={banner1} alt="Пиломатериалы" /></NavLink>
                                <div className="banner_content">
                                    <h3>Пиломатериалы</h3>
                                    <h2>Доска<br/>Пола</h2>
                                    <NavLink to={CATEGORY_FLOOR_BOARD}>Перейти</NavLink>
                                </div>
                            </div>
                        </figure>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <figure className="single_banner">
                            <div className="banner_thumb">
                                <NavLink to={CATEGORY_IMITATION_TIMBER}><img src={banner2} alt="Пиломатериалы" /></NavLink>
                                <div className="banner_content">
                                    <h3>Пиломатериалы</h3>
                                    <h2>Имитация<br/>Бруса</h2>
                                    <NavLink to={CATEGORY_IMITATION_TIMBER}>Перейти</NavLink>
                                </div>
                            </div>
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;